import BotoesSalvarExcluir from '@/shared/components/forms/BotoesSalvarExcluir';
import Links from '@/shared/constants/navegacao';
import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import ModalHistorico from '@/modules/system/historico/ModalHistorico';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { CreateInstituicaoEnsinoDto, ReadInstituicaoEnsinoDto, UpdateInstituicaoEnsinoDto } from '@/api.types';
import { EditadoPorRodape } from '@/shared/components/EditadoPorRodape';
import { FormataTelefone } from '@/shared/utils/telefones';
import { InstituicaoEnsinoService } from '@/modules/structure/instituicoes/instituicao.service';
import { useNavigate } from 'react-router-dom';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Tabelas } from '@/shared/constants/tables';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { validaCNPJ } from '@/shared/utils/cnpj';

export default function InstituicoesEditPage() {
  const { register, handleSubmit, reset, getValues, setValue } = useForm<ReadInstituicaoEnsinoDto>();
  const { setActions } = useBreadcrumbActions();
  const instituicaoService = new InstituicaoEnsinoService();

  const navigate = useNavigate();
  const params = useParams();
  const [modaExcluirShow, setModalExcluirShow] = useState(false);
  const [modalHistorico, setModalHistorico] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const id = params.id ? Number(params.id) : 0;
  const btnSalvar = id > 0 ? 'Salvar' : 'Cadastrar';

  useEffect(() => {
    setActions({
      secondary: { label: 'Novo', href: Links.Instituicoes_Criar, onClick: () => {} },
      history: { label: 'Histórico', onClick: () => setModalHistorico(true) },
    });
    return () => setActions({});
  }, [setActions]);

  useEffect(() => {
    if (id > 0)
      instituicaoService
        .Read(id)
        .then((result) => {
          if (result) {
            result.cnpj = validaCNPJ(result.cnpj, true);

            if (result.telefone && result.telefone.numero)
              result.telefone.numero = FormataTelefone(result.telefone.numero);

            reset(result);
          }
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });
  }, [id]);

  const onSubmit: SubmitHandler<ReadInstituicaoEnsinoDto> = (data) => {
    setIsLoading(true);
    const { criadoEm, criadoPor, ...rest } = data;
    const payload: UpdateInstituicaoEnsinoDto = rest;

    if (id) {
      instituicaoService
        .Update(id, payload)
        .then(() => {
          toast.success('Instituição atualizada com sucesso.');
          navigate(`${Links.Instituicoes_Index}`);
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });
    } else {
      instituicaoService
        .Create(payload as CreateInstituicaoEnsinoDto)
        .then(() => {
          toast.success('Instituição criada com sucesso.');
          navigate(`${Links.Instituicoes_Index}`);
        })
        .catch((res) => {
          toast.error((res as string) + '');
        })
        .finally(() => setIsLoading(false));
    }
  };

  const handleExcluir = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setModalExcluirShow(false);
    instituicaoService
      .Delete(id)
      .then(() => {
        toast.success('Instituição removida.');
        navigate(`${Links.Instituicoes_Index}`);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3 className="pt-4">Instituição de Ensino</h3>
        </div>
      </div>
      <hr className="pb-4" />

      <form
        onSubmit={(event) => {
          void handleSubmit(onSubmit)(event);
        }}
      >
        <div className="row">
          <div className="mb-3 col-md-1">
            <label htmlFor="ordem" className="form-label">
              Ordem:{' '}
            </label>
            <input
              id="ordem"
              type="number"
              title="Ordem no relatório"
              className="form-control"
              min={0}
              defaultValue={0}
              {...register('ordem')}
            />
          </div>

          <div className="mb-3 col-md-3">
            <label htmlFor="cnpj" className="form-label">
              CNPJ:
            </label>
            <input
              id="cnpj"
              autoFocus={true}
              title="CNPJ"
              type="text"
              className="form-control"
              maxLength={18}
              {...register('cnpj', {
                onChange: (e) => {
                  const value = e.target.value;
                  setValue('cnpj', validaCNPJ(value, true));
                },
              })}
            />
          </div>

          <div className="mb-3 col-md-8">
            <label htmlFor="razao_social" className="form-label">
              Razão Social:
            </label>
            <input
              id="razao_social"
              title="Razão Social"
              type="text"
              className="form-control"
              {...register('razao_social')}
            />
          </div>

          <div className="mb-3 col-md-4">
            <label htmlFor="representante_cargo" className="form-label">
              Cargo do representante:
            </label>
            <input
              id="representante_cargo"
              autoFocus={true}
              title="Cargo do representante"
              type="text"
              className="form-control"
              {...register('representante_cargo')}
            />
          </div>

          <div className="mb-3 col-md-4">
            <label htmlFor="representante_nome" className="form-label">
              Representante:
            </label>
            <input
              id="representante_nome"
              autoFocus={true}
              title="Representante"
              type="text"
              className="form-control"
              {...register('representante_nome')}
            />
          </div>

          <div className="col-md-8 p-3">
            <div className="card">
              <div className="card-header">
                <span>Endereço</span>
              </div>
              <div className="card-body row">
                <div className=" col-md-4">
                  <label htmlFor="cep" className="form-label">
                    CEP:
                  </label>
                  <input
                    id="cep"
                    title="CEP"
                    type="text"
                    className="form-control"
                    maxLength={8}
                    {...register('endereco.cep')}
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="cidade" className="form-label">
                    Cidade:
                  </label>
                  <input
                    title="Cidade"
                    type="text"
                    className="form-control"
                    {...register('endereco.cidade')}
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="bairro" className="form-label">
                    Bairro:
                  </label>
                  <input
                    title="Bairro"
                    type="text"
                    className="form-control"
                    {...register('endereco.bairro')}
                  />
                </div>
                <div className="col-md-5">
                  <label htmlFor="logradouro" className="form-label">
                    Logradouro:
                  </label>
                  <input
                    title="Logradouro"
                    type="text"
                    className="form-control"
                    {...register('endereco.logradouro')}
                  />
                </div>
                <div className="col-md-5">
                  <label htmlFor="complemento" className="form-label">
                    Complemento:
                  </label>
                  <input
                    title="Complemento"
                    type="text"
                    className="form-control"
                    {...register('endereco.complemento')}
                  />
                </div>
                <div className="col-md-2">
                  <label htmlFor="numero" className="form-label">
                    Número:
                  </label>
                  <input
                    title="Número"
                    type="text"
                    className="form-control"
                    {...register('endereco.numero')}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4 p-3">
            <div className="card">
              <div className="card-header">
                <span>Telefone</span>
              </div>
              <div className="card-body row">
                <div className="col-md-4">
                  <label htmlFor="telefone_ddd" className="form-label">
                    DDD:
                  </label>
                  <input
                    id="telefone_ddd"
                    type="number"
                    className="form-control"
                    maxLength={3}
                    min={0}
                    max={99}
                    defaultValue={79}
                    {...register('telefone.ddd')}
                  />
                </div>
                <div className="col-md-8 mb-3">
                  <label htmlFor="telefone_numero" className="form-label">
                    Telefone:
                  </label>
                  <input
                    id="telefone_numero"
                    type="text"
                    className="form-control"
                    maxLength={10}
                    {...register('telefone.numero', {
                      onChange: (e) => {
                        const value = e.target.value;
                        setValue('telefone.numero', FormataTelefone(value));
                      },
                    })}
                  />
                </div>
              </div>
            </div>
          </div>

          <EditadoPorRodape
            dados={{
              editadoPor: {
                username: getValues()?.editadoPor?.username
              },
              editadoEm: getValues()?.editadoEm,
            }}
          />
          <div>
            <BotoesSalvarExcluir
              isLoading={isLoading}
              texto={btnSalvar}
              textoLoading={btnSalvar === 'Cadastrar' ? ' Cadastrando...' : ' Salvando...'}
              id={id}
              onExcluirClick={() => setModalExcluirShow(true)}
            />
          </div>
        </div>
      </form>

      <ModalExcluir
        show={modaExcluirShow}
        handleExcluir={handleExcluir}
        handleHide={() => setModalExcluirShow(false)}
      ></ModalExcluir>
      <ModalHistorico
        show={modalHistorico}
        handleHide={() => setModalHistorico(false)}
        tabela={Tabelas.instituicao_ensino}
        idRegistro={id}
      ></ModalHistorico>
    </>
  );
}
